module.exports = __webpack_public_path__ + "static/media/mybb.ad7aa45b.svg";